import { render, staticRenderFns } from "./LabelStatus.vue?vue&type=template&id=8f405d50&scoped=true"
import script from "./LabelStatus.vue?vue&type=script&lang=ts"
export * from "./LabelStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f405d50",
  null
  
)

export default component.exports